import { queryClient } from "@/ReactQuery/reactQueryClient";

const updateFileDetailsInRQ = (
  details: { fileId: string } & Record<string, any>
) => {
  queryClient.setQueryData(["orgFileList"], (oldData: any) => {
    return oldData.map((file: any) =>
      file.fileId === details.fileId ? { ...file, ...details } : file
    );
  });
};

export default updateFileDetailsInRQ;
